<template>
    <div class="info-body">
        <my-header title="个人信息" :is-back="true"/>
        <div class="cell-wrap">

            <van-cell title="头像" @click="showEdit('profile')">
                <template #title>
                    <div class="in-center">头像</div>
                </template>
                <template #value>
                    <van-image :src="userinfo.profile"
                               width="15vw" height="15vw"
                               radius="50%" fit="cover"
                    />
                </template>
            </van-cell>

            <van-cell title="昵称" :value="userinfo.username"
                      @click="showEdit('username')" is-link/>
            <van-cell title="手机号" :value="userinfo.phone"
                      @click="showEdit('phone')" is-link/>
            <van-cell title="性别" :value="userinfo.gender || '未设置'"
                      @click="showEdit('gender')" is-link/>
        </div>

        <!-- 信息编辑区域 -->
        <van-popup v-model:show="show" position="bottom" round :style="{height:'40%'}">
            <van-form class="form" @submit="onSubmit">

                <!-- 用户头像 -->
                <van-field name="profile" label="用户头像" v-if="formType === 'profile'">
                    <template #input>
                        <van-uploader v-model="fileList" :max-count="1"
                                      :after-read="afterImgRead" />
                    </template>
                </van-field>

                <!-- 用户昵称 -->
                <van-field v-if="formType === 'username'"
                    v-model="form.username"
                    name="昵称"
                    label="昵称"
                    placeholder="请输入昵称"
                    :rules="rules.username"
                />

                <!-- 手机号 -->
                <van-field v-if="formType === 'phone'"
                    v-model="form.phone"
                    name="手机号"
                    label="手机号"
                    placeholder="请输入手机号"
                    :rules="rules.phone"
                />
                <!-- 短信验证码 -->
                <sms-code :form="form" v-if="formType === 'phone'"/>

                <!-- 性别 -->
                <van-field name="gender" label="单选框" v-if="formType === 'gender'">
                    <template #input>
                        <van-radio-group v-model="form.gender" direction="horizontal">
                            <van-radio name="男">男</van-radio>
                            <van-radio name="女">女</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <div style="margin: 16px;">
                    <van-button round block type="primary" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </van-popup>
    </div>
</template>

<script>
import {uploadProfile,doUpdate} from "@/api/CommonApi";
import MyHeader from "@/components/myHeader";
import {getUserinfo} from "@/api/CommonApi";
import {Toast} from "vant";
import SmsCode from "@/views/my/login/sms-code";

export default {
    name: "UserInfo",
    components:{MyHeader,SmsCode},
    data(){
        return{
            formType:null,
            // 显示弹框
            show:false,
            userinfo:{},
            fileList:[],
            // 表单
            form:{
                username: null,
                phone: null,
                code: null,
                gender: null,
            },
            rules: {
                // 手机号
                phone: [
                    {require: true, trigger: 'blur',message:'请输入手机号'},
                    {
                        pattern:/^1[3456789]\d{9}$/,
                        trigger: 'blur',
                        message: '请输入正确的手机号码'
                    }
                ],
                // 昵称
                username: [
                    {require: true, trigger: 'blur',message:'请输入昵称'},
                ],
            }
        }
    },
    created() {
        this.getUserInfo();
    },
    methods:{
        getUserInfo(){
            getUserinfo().then(res => {
                this.userinfo = res.result
            }).catch(() => {
                // 登录状态失效,跳转到登录页
                Toast.fail('登录状态失效,请重新登录')
                return this.$router.replace('/login')
            })
        },
        showEdit(v){
            console.log(v)
            this.show = true
            this.initForm()
            this.formType = v
        },
        onSubmit(){
            console.log('submit')
            // 编辑头像模式
            if(this.formType === 'profile'){
                console.log('profile')
                this.editProfile()
                return
            }
            const form = {...this.form}
            form.smsCode = form.code
            // 编辑用户信息
            doUpdate(form).then(res => {
                Toast.success(res.message)
                this.show = false
                // 刷新用户信息
                this.getUserInfo()
            })
        },
        // 初始化表单
        initForm(){
            // 初始化上传文件列表
            this.fileList = [{url:this.userinfo.profile,isImage: true}]
            this.form = {
                username: this.userinfo.username,
                phone: null,
                code: null,
                gender: this.userinfo.gender,
            }
        },
        /** 组件读取到头像信息后 */
        afterImgRead(info){
            const file = info.file
            const isJPG = file.type.indexOf('image/') === 0; //file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                Toast.fail('该格式图片无法上传!');
                this.show = false
                return;
            }
            if (!isLt2M) {
                Toast.fail('上传头像图片大小不能超过 2MB!');
                this.show = false
                return;
            }
        },
        /** 编辑用户头像 */
        editProfile(){
            if(!this.fileList || !this.fileList.length) return;
            const file = this.fileList[0].file
            // 上传
            uploadProfile(file).then(res => {
                Toast.success(res.message)
                this.show = false
                this.userinfo.profile = res.result
            }).catch(err => {
                Toast.fail(err.message)
            })
        }
    }
}
</script>

<style scoped>
.info-body{
    background: #E5E5E5;
}
.cell-wrap{
    background-color: #FFF;
    padding: 0 5px;
}
.in-center{
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
}

.form{
    width: 90vw;
    margin: 4vw auto;
}
</style>
